/*
 * Homepage videos, cloned from the competitor behaviour:
 * - customer video cards ([data-sfh-video]): a tap swaps the poster for the video (kept in a <template>
 *   so nothing downloads before that) and plays it with sound and controls; starting one pauses the others.
 * - lab proof clip ([data-sfh-autoplay]): muted loop that only plays while at least half of it is on screen.
 */
(function () {
  'use strict';
  if (window.SeatFitHomeMedia) return;
  var api = window.SeatFitHomeMedia = {};

  function pauseOthers(except) {
    document.querySelectorAll('[data-sfh-video] video').forEach(function (v) { if (v !== except) v.pause(); });
  }

  function playCard(card) {
    var video = card.querySelector('video');
    if (!video) {
      var tpl = card.querySelector('template');
      if (!tpl) return;
      card.appendChild(tpl.content.cloneNode(true));
      video = card.querySelector('video');
      if (!video) return;
      video.setAttribute('playsinline', '');
      video.controls = true;
    }
    card.classList.add('is-playing');
    pauseOthers(video);
    var p = video.play();
    if (p && p.catch) p.catch(function (e) { console.warn('[home videos] play() was blocked', e); });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest ? e.target.closest('[data-sfh-video]') : null;
    if (card && !card.classList.contains('is-playing')) playCard(card);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var card = e.target.closest ? e.target.closest('[data-sfh-video]') : null;
    if (card && e.target === card && !card.classList.contains('is-playing')) { e.preventDefault(); playCard(card); }
  });
  document.addEventListener('play', function (e) {
    if (e.target.closest && e.target.closest('[data-sfh-video]')) pauseOthers(e.target);
  }, true);

  // Shrine's background/container videos ship their sources as <source data-src> and rely on Shrine's own
  // autoplay observer to copy them into src. seatfit-video-diet switches that observer off, so without this
  // the clip has no source at all and play() never loads anything (hero, install and fabric loops stayed blank).
  // Shopify lists the HLS playlist first; for these short muted loops it took 5-8 s to show a first frame
  // against ~1 s for the progressive mp4, so the playlist is dropped when an mp4 is there to fall back on.
  function ensureSource(v) {
    if (v.hasAttribute('data-sfh-ready')) return;
    v.setAttribute('data-sfh-ready', '');
    var changed = false;
    var pending = v.querySelectorAll('source[data-src]');
    for (var i = 0; i < pending.length; i++) {
      pending[i].setAttribute('src', pending[i].getAttribute('data-src'));
      pending[i].removeAttribute('data-src');
      changed = true;
    }
    if (v.querySelector('source[type="video/mp4"]')) {
      var hls = v.querySelectorAll('source[type="application/x-mpegURL"]');
      for (var j = 0; j < hls.length; j++) { hls[j].parentNode.removeChild(hls[j]); changed = true; }
      // Shrine may already have removed the playlist <source> after the browser picked it; reload to switch.
      if (/\.m3u8/i.test(v.currentSrc || '')) changed = true;
    }
    if (changed) v.load();
  }

  function watchAutoplay(root) {
    var clips = root.querySelectorAll('[data-sfh-autoplay]');
    if (!clips.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio >= 0.5) {
          try { ensureSource(v); } catch (e) { /* a broken source must not stop the other clips */ }
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: [0, 0.5] });
    clips.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watchAutoplay(document); });
  else watchAutoplay(document);
  // Theme editor: a re-rendered section brings a new clip element.
  document.addEventListener('shopify:section:load', function (e) { watchAutoplay(e.target); });
  // Cards a script puts in later (a Style switch swaps a slider's cards: seatfit-style-state.js) are watched on request.
  api.watch = watchAutoplay;
})();
